<template>
  <v-dialog :model-value="value" max-width="400" @click:outside="$emit('close')">
    <v-card>
      <v-card-title class="pt-4">Generate reinforcements</v-card-title>
      <v-card-text class="pt-0 pl-4"> Do you want to continue? </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn :loading="loading" @click="$emit('generate')" color="primary" text>
          Continue to save & generate
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'GenerateReinforcementsDialog',
  props: {
    value: { type: Boolean, required: true },
    loading: { type: Boolean, default: false }
  }
}
</script>
